import { Button, Form, Input, Modal } from "antd";
import { useEffect, useState } from "react";
import { aadharPattern, dispatchtoast, getLocalStorageItem } from "../../../../Utils";
import { useDispatch } from "react-redux";
import { setselectedTab } from "../../../../Store/B2bslice";
import CommonInput from "../../../../Common/CommonInput";
import { DoEkoAadharVerify, EkoAadharConcent, EkoAadharOtp } from "../EkoEndpoint";

const EkoAadharVerify = () => {
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [btnLoading, setBtnLoading] = useState(false)
    const [otp, setOtp] = useState(null)
    const [accessKey, setAccessKey] = useState(null)
    const [openOtpModal, setOpenOtpModal] = useState(false)

    const hanldeConcent = (v) => {
        setBtnLoading(true)
        EkoAadharConcent(v).then(res => {
            if (res.status) {
                setAccessKey(res.access_key)
                EkoAadharOtp({ aadhar_number: v.aadhar_number, access_key: res.access_key }).then(res => {
                    if (res.status) {
                        setOpenOtpModal(true)
                    }
                }).catch(err => console.log(err)).finally(()=>setBtnLoading(false))
            }
        }).catch(err => console.log(err))
    }
    const handleVerify = () => {
        setBtnLoading(true)
        const formdata = new FormData()
        formdata.append("latitude", getLocalStorageItem("latitude"))
        formdata.append("access_key", accessKey)
        formdata.append("otp", otp)
        formdata.append("aadhar_number", form.getFieldValue("aadhar_number"))
        formdata.append("longitude", getLocalStorageItem("longitude"))
        DoEkoAadharVerify(formdata).then(res => {
            if (res.status) {
                dispatchtoast(res.message+" "+`Name is ${res.data.verify_name}`)
            }
        }).catch(err => console.log(err)).finally(() => {
            setBtnLoading(false)
            form.resetFields()
            setOpenOtpModal(false)
        })

    }
    useEffect(() => {
        dispatch(setselectedTab("300.8"))
    }, [])
    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
                <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
                    <p className="font-bold text-[15px] mb-2"> Aadhar Verify</p>
                    <Form
                        name="form"
                        form={form}
                        onFinishFailed={(err) => console.log(err)}
                        onFinish={(val) => hanldeConcent(val)}
                    >

                        <Form.Item
                            name={`aadhar_number`}
                            label={"Aadhar Number"}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Enter Aadhar!",
                                },
                                {
                                    pattern: aadharPattern,
                                    message: "Enter valid Aadhar!",
                                },
                                {
                                    whitespace: true,
                                    message: "Field cannot contain only blank spaces",
                                },
                            ]}
                        >
                            <CommonInput
                                placeholder="Enter Aadhar"
                            />
                        </Form.Item>{" "}

                        {/* )} */}
                        <Button
                            loading={btnLoading}
                            className="w-full bg-primary border-none mt-4"
                            style={{ color: "white" }}
                            htmlType="submit"
                        >
                            Verify
                        </Button>
                    </Form>
                </div>
            </div>
            {openOtpModal && <Modal
                title={"Verify OTP"}
                footer={null}
                className="shadow-normal"
                width={300}
                maskClosable={false}
                open={openOtpModal}
                onCancel={() => setOpenOtpModal(false)}
            >
                <div className="  rounded-3xl shadow-normal bg-white ">
                    <Form onFinish={(v) => handleVerify(v)} labelCol={{ span: 24 }}>
                        <Form.Item name={"otp"} label="otp" rules={[{
                            required: true,
                            message: "Enter otp"
                        }]}>
                            <div className=" mt-5 flex justify-center items-center">
                                <Input.OTP onChange={v => setOtp(v)} />
                            </div>
                        </Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={btnLoading}
                            className={`SignInBtn w-full flex justify-center border-none items-center h-12 mt-4  rounded-full text-white text-[12px] font-bold`}
                        >
                            <p>Verify OTP</p>
                        </Button>
                    </Form>

                </div>
            </Modal>}
        </>
    )
}

export default EkoAadharVerify